var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1332,
    height: 526,
    viewBox: "0 0 1332 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2954_4804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1332,
    height: 526
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1332 0H0V525.404H1332V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2954_4804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.012 156.916L538.267 142.085L537.142 124.577L560.914 114.885L638.173 118.764L641.739 535.379L643.697 536.031V604.824H539.763V605.938L515.012 599.315V156.916Z",
    fill: "#27274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.96 271.182L922.059 287.992L919.145 591.354L904.046 594.423L906.96 602.857H812.68V271.182H906.96Z",
    fill: "#27274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.112 547.579L123.026 227.609H175.376L189.855 237.302L191.577 256.935H244.646L258.079 269.652L272.874 713.613H248.561L244.646 721.001H118.965V547.557L120.112 547.579Z",
    fill: "#072747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.409 322.996L430.508 339.806L427.605 643.168L412.507 646.238L415.409 654.671H321.129V322.996H415.409Z",
    fill: "#27274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.4 305.41L1187.5 322.22L1184.58 625.582L1169.48 628.652L1172.4 637.085H1078.12V305.41H1172.4Z",
    fill: "#072747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.012 611.368L428.818 226.529L437.875 209.033H496.435V229.093H507.314V611.941H432.947L429.763 611.368H422.012Z",
    fill: "#27274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.137 636.454L945.943 251.615L955 234.119H1013.56V254.179H1024.44V637.027H950.072L946.888 636.454H939.137Z",
    fill: "#27274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.79 126.207L856.524 111.376L857.649 93.8684L833.876 84.1758L756.618 88.0663L753.051 504.67L751.094 505.334V574.115H855.027V575.24L879.79 568.606V126.207Z",
    fill: "#101128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.488 443.95L747.574 123.969H695.236L680.745 133.673L679.024 153.305H625.966L612.521 166.023L597.727 609.984H622.039L625.966 617.371H751.636V443.927L750.488 443.95Z",
    fill: "#101128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.829 240.473L472.73 257.283L475.644 560.645L490.743 563.714L487.829 572.148H582.109V240.473H487.829Z",
    fill: "#101128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.68 516.87L1271.76 196.9H1219.42L1204.93 206.604L1203.21 226.226H1150.15L1136.71 238.943L1121.91 682.916H1146.23L1150.15 690.292H1275.82V516.859L1274.68 516.87Z",
    fill: "#101128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.453 489.997L215.539 170.027H163.201L148.711 179.731L146.989 199.353H93.931L80.4978 212.07L65.7031 656.043H90.0046L93.931 663.419H219.601V489.986L218.453 489.997Z",
    fill: "#101128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.91 144.502L1023.81 168.835L1026.72 607.916L1041.82 612.358L1038.91 624.569H1133.19V144.502H1038.91Z",
    fill: "#101128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.391 224.809L207.293 244.149L210.207 593.14L225.305 596.671L222.391 606.375H316.672V224.809H222.391Z",
    fill: "#101128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.776 580.659L965.969 195.82L956.912 178.324H898.352V198.384H887.484V581.244H961.84L965.024 580.659H972.776Z",
    fill: "#101128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.654 565.446L400.836 180.608L391.779 163.111H333.22V183.171H322.352V566.031H396.707L399.902 565.446H407.654Z",
    fill: "#101128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.021 261.791C500.082 259.093 495.132 267.785 498.979 270.978C504.11 275.24 511.501 265.333 505.021 261.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.048 260.567C522.109 257.868 517.159 266.56 521.007 269.753C526.137 274.015 533.529 264.109 527.048 260.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.079 259.959C544.14 257.261 539.19 265.953 543.038 269.146C548.168 273.408 555.56 263.501 549.079 259.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.65 234.894C1193.02 232.746 1189.08 239.122 1191.88 241.618C1195.62 244.946 1201.42 237.705 1196.65 234.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.19 234.546C1209.56 232.399 1205.62 238.774 1208.42 241.27C1212.16 244.599 1217.96 237.369 1213.19 234.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.72 234.66C1226.09 232.512 1222.15 238.887 1224.95 241.384C1228.69 244.723 1234.49 237.482 1229.72 234.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.38 270.843C1188.75 268.695 1184.81 275.071 1187.61 277.567C1191.35 280.896 1197.14 273.665 1192.38 270.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.92 270.505C1205.29 268.358 1201.35 274.733 1204.15 277.229C1207.88 280.558 1213.69 273.316 1208.92 270.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.45 270.618C1221.81 268.471 1217.88 274.846 1220.68 277.343C1224.41 280.671 1230.22 273.441 1225.45 270.618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.6 348.34C1211.66 345.642 1206.71 354.333 1210.56 357.527C1215.69 361.788 1223.09 351.882 1216.6 348.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.037 208.022C917.097 205.323 912.147 214.015 915.995 217.209C921.136 221.481 928.528 211.564 922.037 208.022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.729 293.839C501.341 291.444 496.942 299.169 500.362 302.002C504.93 305.792 511.5 296.987 505.729 293.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.984 195.473C380.239 193.977 377.494 198.801 379.631 200.578C382.478 202.95 386.584 197.441 382.984 195.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.187 195.473C363.442 193.977 360.697 198.801 362.834 200.578C365.681 202.95 369.787 197.441 366.187 195.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.39 195.473C346.645 193.977 343.9 198.801 346.037 200.578C348.884 202.95 353.002 197.441 349.39 195.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.593 195.473C329.848 193.977 327.103 198.801 329.241 200.578C332.087 202.95 336.205 197.441 332.593 195.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.324 213.61C380.579 212.114 377.833 216.938 379.971 218.715C382.817 221.087 386.924 215.577 383.324 213.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.527 213.61C363.782 212.114 361.037 216.938 363.174 218.715C366.021 221.087 370.127 215.577 366.527 213.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.73 213.61C346.985 212.114 344.24 216.938 346.377 218.715C349.224 221.087 353.341 215.577 349.73 213.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.43 163.268C1118.68 161.772 1115.94 166.596 1118.08 168.373C1120.92 170.745 1125.03 165.236 1121.43 163.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.63 163.268C1101.89 161.772 1099.14 166.596 1101.28 168.373C1104.13 170.745 1108.24 165.236 1104.63 163.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.85 163.268C1085.1 161.772 1082.35 166.596 1084.5 168.373C1087.34 170.745 1091.45 165.236 1087.85 163.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.05 163.268C1068.31 161.772 1065.56 166.596 1067.7 168.373C1070.54 170.745 1074.65 165.236 1071.05 163.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.77 181.405C1119.02 179.909 1116.27 184.733 1118.41 186.509C1121.26 188.871 1125.38 183.372 1121.77 181.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.97 181.405C1102.22 179.909 1099.48 184.733 1101.62 186.509C1104.46 188.871 1108.58 183.372 1104.97 181.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.18 181.405C1085.44 179.909 1082.69 184.733 1084.83 186.509C1087.68 188.871 1091.78 183.372 1088.18 181.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.289 104.382C818.465 102.841 815.629 107.811 817.835 109.644C820.76 112.084 824.99 106.417 821.289 104.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.335 115.94C819.512 114.4 816.676 119.37 818.881 121.203C821.818 123.643 826.048 117.964 822.335 115.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.675 104.382C805.851 102.841 803.016 107.811 805.221 109.644C808.146 112.084 812.388 106.417 808.675 104.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.179 116.92C806.434 115.425 803.689 120.248 805.826 122.025C808.673 124.386 812.779 118.877 809.179 116.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.308 143.826C792.563 142.331 789.818 147.155 791.955 148.931C794.802 151.293 798.908 145.794 795.308 143.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.148 163.393C815.403 161.897 812.658 166.721 814.795 168.498C817.642 170.87 821.759 165.361 818.148 163.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.118 184.6C793.372 183.104 790.616 187.928 792.765 189.705C795.611 192.066 799.729 186.556 796.118 184.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.86 121.272C768.115 119.776 765.358 124.6 767.507 126.377C770.353 128.749 774.46 123.239 770.86 121.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.26 251.942C1226.51 250.446 1223.77 255.27 1225.9 257.047C1228.75 259.408 1232.87 253.898 1229.26 251.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.77 251.942C1211.02 250.446 1208.27 255.27 1210.41 257.047C1213.26 259.408 1217.37 253.898 1213.77 251.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.63 220.086C1107.89 218.591 1105.14 223.415 1107.28 225.191C1110.13 227.552 1114.24 222.043 1110.63 220.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.69 213.553C1089.94 212.057 1087.2 216.881 1089.33 218.658C1092.18 221.03 1096.29 215.521 1092.69 213.553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.53 237.199C1081.79 235.704 1079.04 240.528 1081.18 242.304C1084.02 244.677 1088.13 239.167 1084.53 237.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.625 158.377C732.88 156.882 730.124 161.706 732.273 163.482C735.119 165.843 739.226 160.345 735.625 158.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.937 183.666C199.192 182.171 196.447 186.995 198.584 188.771C201.431 191.144 205.548 185.634 201.937 183.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.164 203.242C200.418 201.747 197.673 206.571 199.811 208.347C202.657 210.709 206.764 205.21 203.164 203.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.699 214.25C186.954 212.755 184.208 217.579 186.346 219.355C189.192 221.717 193.31 216.218 189.699 214.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.347 225.258C168.602 223.763 165.857 228.586 167.994 230.363C170.841 232.724 174.947 227.226 171.347 225.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.031 263.174C183.286 261.679 180.54 266.502 182.678 268.279C185.524 270.64 189.642 265.142 186.031 263.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.71 298.651C197.965 297.155 195.22 301.979 197.358 303.756C200.204 306.117 204.322 300.607 200.71 298.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.359 237.696C194.614 236.2 191.869 241.024 194.006 242.8C196.853 245.173 200.97 239.663 197.359 237.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.257 183.666C184.512 182.171 181.767 186.995 183.905 188.771C186.751 191.144 190.858 185.634 187.257 183.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.93 158.377C718.185 156.882 715.428 161.706 717.577 163.482C720.424 165.843 724.541 160.345 720.93 158.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.582 159.604C699.836 158.108 697.091 162.932 699.229 164.709C702.075 167.07 706.182 161.56 702.582 159.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.01 330.619C1210.27 329.124 1207.51 333.948 1209.66 335.724C1212.51 338.097 1216.61 332.587 1213.01 330.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.32 330.619C1195.57 329.124 1192.83 333.948 1194.97 335.724C1197.81 338.097 1201.93 332.587 1198.32 330.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.343 231.893C920.598 230.397 917.853 235.221 919.991 236.998C922.837 239.359 926.955 233.861 923.343 231.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.886 231.893C907.141 230.397 904.396 235.221 906.534 236.998C909.369 239.359 913.486 233.861 909.886 231.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.585 245.139C917.84 243.643 915.095 248.467 917.233 250.244C920.079 252.605 924.186 247.107 920.585 245.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.355 229.442C931.61 227.946 928.865 232.77 931.002 234.547C933.849 236.919 937.966 231.409 934.355 229.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.011 267.155C909.266 265.659 906.521 270.483 908.659 272.259C911.505 274.621 915.611 269.111 912.011 267.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.97 331.844C1177.22 330.348 1174.47 335.172 1176.62 336.949C1179.46 339.31 1183.57 333.812 1179.97 331.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.407 324.682C558.661 323.186 555.905 328.01 558.054 329.787C560.9 332.159 565.007 326.65 561.407 324.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.914 402.74C558.168 401.245 555.423 406.069 557.561 407.845C560.407 410.218 564.525 404.708 560.914 402.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.816 324.895C543.071 323.399 540.326 328.223 542.463 330C545.31 332.372 549.416 326.863 545.816 324.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.07 355.885C515.325 354.39 512.579 359.213 514.717 360.99C517.564 363.363 521.67 357.853 518.07 355.885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.226 104.686C788.481 103.19 785.736 108.014 787.873 109.791C790.72 112.152 794.838 106.654 791.226 104.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.621 128.794C867.797 127.253 864.961 132.223 867.167 134.056C870.103 136.496 874.333 130.818 870.621 128.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.675 140.343C868.851 138.802 866.016 143.772 868.221 145.605C871.146 148.045 875.388 142.367 871.675 140.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.007 128.794C855.183 127.253 852.348 132.223 854.553 134.056C857.49 136.496 861.72 130.818 858.007 128.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.234 186.094C854.489 184.598 851.744 189.422 853.881 191.199C856.728 193.571 860.845 188.062 857.234 186.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.992 155.813C869.247 154.317 866.501 159.141 868.639 160.918C871.485 163.29 875.592 157.781 871.992 155.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.32 184.227C731.496 182.687 728.661 187.657 730.866 189.49C733.802 191.93 738.033 186.263 734.32 184.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.374 195.786C732.551 194.246 729.715 199.216 731.921 201.048C734.846 203.488 739.076 197.81 735.374 195.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.707 184.227C718.883 182.687 716.047 187.657 718.253 189.49C721.189 191.93 725.419 186.263 721.707 184.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.214 196.754C719.469 195.259 716.724 200.082 718.862 201.859C721.708 204.232 725.826 198.722 722.214 196.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.351 223.662C705.606 222.167 702.861 226.991 704.998 228.767C707.845 231.14 711.951 225.63 708.351 223.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.191 243.239C728.446 241.743 725.701 246.567 727.838 248.343C730.685 250.705 734.791 245.206 731.191 243.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.164 264.434C706.418 262.938 703.673 267.762 705.811 269.539C708.657 271.911 712.764 266.402 709.164 264.434Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.7643bf68d5dbf97847cc887bf5f5ce5f.svg";
export { ForwardRef as ReactComponent };